import { navigate } from "../../../service/navigation/Navigation";
import { appRoutes } from "../../../routes/routes";
import CacheStorage from "../../../service/storage/CacheStorage";
import Loader from "../../../widget/common/ui/Loader";
import StorageKeys from "../../../const/StorageKeys";
import { deviceInfo } from "../../../service/device_info/DeviceInfo";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import ShowToast from "../../../widget/common/ui/Toast";
import { LoginModel, ProfileDetails } from "../../../model/login/LoginModel";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import SessionStorage from "../../../service/storage/SessionStorage";
import { companiesRequiredPhoneNumber } from "../../../const/CompaniesRequiredPhone";

const LoginProvider = new (class LoginProvider {
  setupDetaults = () => {
    // SET DEFAULT VERIFICATION TYPE
    // email=0, phone=1
    let verfificationTypeDefault =
      process.env.REACT_APP_defaults_verification_type ?? "email";

    const code: string = UtilityHelper.getUrlCompanyCode();
    if (companiesRequiredPhoneNumber.includes(code)) {
      verfificationTypeDefault = "phone";
    }

    SessionStorage.saveValue(
      StorageKeys.verification_type,
      verfificationTypeDefault
    );

    //this.resetTheme();
    //SessionStorage.saveValue(StorageKeys.verification_type, "phone");
  };

  signIn = async (
    email: string,
    phone: string,
    password: string,
    tabName: "email" | "phone"
  ): Promise<null | true | "no_default_branch"> => {
    ApiUrls.init();

    const deviceToken: string = CacheStorage.getValue(StorageKeys.device_token);
    const appId: string = CacheStorage.getValue(StorageKeys.app_id);
    const deviceId: string = CacheStorage.getValue(StorageKeys.device_id);
    const deviceName: string = deviceInfo.userAgent;
    const devicePlatform: string = "4"; // web

    phone = phone.replaceAll("+", "");

    const url: string = `${ApiUrls.baseUrl}device/login`;
    const body: any = {
      app_id: appId,
      flag: tabName === "email" ? "0" : "1",
      email: tabName === "email" ? email.trim() : "",
      mobile_number: tabName === "email" ? "" : phone.trim(),
      password: password,
      device_id: deviceId,
      device_model: deviceName,
      device_platform: devicePlatform,
      fcm_token: deviceToken,
    };

    console.log(body);

    const response: any = await ApiService.postApi(url, body);

    if (response != null) {
      if (response["success"] === "1") {
        const returnValue: true | "no_default_branch" =
          this.extracLoginDetail(response);

        return returnValue;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    } else {
      ShowToast.error(AppTranslation.text("something_went_wrong"));
      //ShowToast.error(response["errorMessage"]);
    }

    return null;
  };

  signInBySocial = async ({
    socialType,
    socialEmail,
    socialId,
    socialToken,
  }: {
    socialType: string;
    socialEmail: string;
    socialId: string;
    socialToken: string;
  }): Promise<null | true | "no_default_branch"> => {
    ApiUrls.init();

    const deviceToken: string = CacheStorage.getValue(StorageKeys.device_token);
    const appId: string = CacheStorage.getValue(StorageKeys.app_id);
    const deviceId: string = CacheStorage.getValue(StorageKeys.device_id);
    const deviceName: string = deviceInfo.userAgent;
    const devicePlatform: string = "4"; // web

    const url: string = `${ApiUrls.baseUrl}device/login_socialmedia`;
    const body: any = {
      app_id: appId,
      device_id: deviceId,
      device_model: deviceName,
      device_platform: devicePlatform,
      fcm_token: deviceToken,
      email_id: socialEmail,
      socialmedia_app_type: socialType,
      socialmedia_app_id: socialId,
      socialmedia_access_token: socialToken,
    };

    console.log(body);

    const response: any = await ApiService.postApi(url, body);

    if (response != null) {
      if (response["success"] === "1") {
        const returnValue: true | "no_default_branch" =
          this.extracLoginDetail(response);

        return returnValue;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    } else {
      ShowToast.error(AppTranslation.text("something_went_wrong"));
    }
    return null;
  };

  extracLoginDetail = (response: any): true | "no_default_branch" => {
    const loginModel: LoginModel = response;
    const loginStatus: string = loginModel.result?.login_response?.status!;
    if (loginStatus === "1") {
      const profileDetails: ProfileDetails =
        loginModel.result?.login_response?.profile_details!;

      const branchId: string =
        profileDetails.default_branch_details?.branch_id! ?? "";

      CacheStorage.saveValue(StorageKeys.launch_status, "1");

      CacheStorage.saveValue(
        StorageKeys.company_id,
        profileDetails.company_id!
      );
      CacheStorage.saveValue(
        StorageKeys.account_id,
        profileDetails.account_id!
      );
      CacheStorage.saveValue(StorageKeys.name, profileDetails.name!);
      CacheStorage.saveValue(StorageKeys.logo, profileDetails.logo!);
      CacheStorage.saveValue(StorageKeys.status, profileDetails.status!);
      CacheStorage.saveValue(
        StorageKeys.public_key,
        profileDetails.encryption_keys?.public_key!
      );
      CacheStorage.saveValue(
        StorageKeys.private_key,
        profileDetails.encryption_keys?.private_key!
      );
      CacheStorage.saveValue(StorageKeys.login_status, "1");

      if (UtilityHelper.isNotEmpty(branchId.trim())) {
        CacheStorage.saveValue(StorageKeys.branch_id, branchId);

        navigate(appRoutes.routeNameHome);
        return true;
      } else {
        // BRANCH SELECTION CODE HERE
        return "no_default_branch";
      }
    }

    return "no_default_branch";
  };

  setUpGuestBranch = (branchId: string, redirect: boolean = false) => {
    if (UtilityHelper.isNotEmpty(branchId)) {
      SessionStorage.deleteValue(StorageKeys.signup_verification_detail);
      SessionStorage.deleteValue(StorageKeys.account_id);

      CacheStorage.saveValue(StorageKeys.branch_id, branchId);

      SessionStorage.saveValue(StorageKeys.guest_status, "1");
      CacheStorage.saveValue(StorageKeys.login_status, "1");

      if (redirect) {
        navigate(appRoutes.routeNameHomeGuest, { replace: true });
      }

      //navigate(appRoutes.routeNameHomeGuest, { replace: true });
      /* if (reload) {
        navigate(0);
      } else {
        navigate(appRoutes.routeNameHomeGuest, { replace: true });
      } */
    }
  };

  resetTheme = () => {
    console.log("resetTheme");
    CacheStorage.saveValue(
      StorageKeys.web_app_config,
      CacheStorage.getValue(StorageKeys.web_app_config_default)
    );
  };

  logout = async () => {
    ApiUrls.init();

    const appId = CacheStorage.getValue(StorageKeys.app_id);
    const deviceId = CacheStorage.getValue(StorageKeys.device_id);
    const accountId = CacheStorage.getValue(StorageKeys.account_id) ?? "0";

    const url: string = `${ApiUrls.baseUrl}device/logout`;
    const body: any = {
      app_id: appId,
      account_id: accountId,
      device_id: deviceId,
    };

    Loader.modal();
    const response: any = await ApiService.postApi(url, body);
    Loader.modal(false);

    if (response != null) {
      if (response["success"] === "1") {
        SessionStorage.clearAll();
        CacheStorage.clearAll();

        CacheStorage.deleteValue(StorageKeys.login_status);

        CacheStorage.saveValue(
          StorageKeys.app_id,
          response["result"]["device_details"]["app_id"].toString()
        );
        CacheStorage.saveValue(
          StorageKeys.api_token,
          response["result"]["device_details"]["api_token"].toString()
        );
        CacheStorage.saveValue(
          StorageKeys.refresh_token,
          response["result"]["device_details"]["refresh_token"].toString()
        );

        this.resetTheme();

        navigate(appRoutes.routeNameLogin, { replace: true });
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    } else {
      ShowToast.error(AppTranslation.text("something_went_wrong"));
    }
  };
})();

export default LoginProvider;
